var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: _vm.panelClasses, attrs: { id: "email-panel-handler" } },
    _vm._l(_vm.emailPanels, function(panel) {
      return _c(
        "div",
        { key: panel.id },
        [
          panel.typePanel === "create"
            ? _c("EmailPanel", {
                attrs: {
                  id: "email-panel-" + panel.id,
                  hashPanel: panel.id,
                  isPanelMinimized: panel.isMinimized,
                  prefill: panel.prefill,
                  linkEmail: panel.email,
                  linkedType: panel.linkedType,
                  linkedId: panel.linkedId,
                  signature: panel.signature,
                  doclabel: panel.doclabel,
                  docFile: panel.docFile,
                  resendAttachments: panel.attachments,
                  description: panel.description,
                  linkedObject: panel.linkedObject,
                  resendDatas: {
                    resendSubject: panel.subject,
                    resendRecipients: panel.recipients,
                    objectid: panel.objectid
                  },
                  template: panel.template,
                  showCustomTemplates: panel.showCustomTemplates
                },
                on: {
                  "toggle-panel-state": function($event) {
                    return _vm.togglePanelState(panel)
                  },
                  "open-panel": function($event) {
                    return _vm.openPanel(panel.id)
                  },
                  "close-panel": function($event) {
                    return _vm.closePanel(panel.id)
                  }
                }
              })
            : panel.typePanel === "consult"
            ? _c("EmailConsultPanel", {
                attrs: {
                  id: "email-panel-" + panel.id,
                  hashPanel: panel.id,
                  isPanelMinimized: panel.isMinimized,
                  prefill: panel.prefill,
                  linkEmail: panel.email,
                  linkedType: panel.linkedType,
                  linkedId: panel.linkedId,
                  threadId: panel.threadId,
                  messageId: panel.messageId,
                  attachments: panel.attachments,
                  description: panel.description,
                  prefillSubject: panel.subject,
                  sending_type: panel.sending_type,
                  linked_object: panel.linked_object,
                  prefillEmailTo: panel.emailTo,
                  objectid: panel.objectid,
                  isFromProvider: panel.isFromProvider,
                  readProviderThreadLink: panel.readProviderThreadLink
                },
                on: {
                  "open-panel": function($event) {
                    return _vm.openPanel(panel.id)
                  },
                  "close-panel": function($event) {
                    return _vm.closePanel(panel.id)
                  },
                  "toggle-panel-state": function($event) {
                    return _vm.togglePanelState(panel)
                  }
                }
              })
            : panel.typePanel === "preview"
            ? _c("EmailPreviewPanel", {
                attrs: {
                  id: "email-panel-" + panel.id,
                  hashPanel: panel.id,
                  isPanelMinimized: panel.isMinimized,
                  email: panel.email,
                  thread: panel.thread
                },
                on: {
                  "open-panel": function($event) {
                    return _vm.openPanel(panel.id)
                  },
                  "close-panel": function($event) {
                    return _vm.closePanel(panel.id)
                  },
                  "toggle-panel-state": function($event) {
                    return _vm.togglePanelState(panel)
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }